// Mock data generator for athlete profiles
export const generateMockAthleteProfile = (id) => {
  return {
    id,
    firstName: "John",
    lastName: "Smith",
    fullName: "John Smith",
    position: "Quarterback",
    height: 75, // in inches
    weight: 195, // in pounds
    school: "Central High School",
    location: "Austin, TX",
    graduationYear: 2024,
    stars: 4,
    ranking: {
      national: 125,
      position: 15,
      state: 8,
    },
    contact: {
      phone: "(555) 123-4567",
      email: "john.smith@example.com",
      twitter: "@johnsmith12",
      instagram: "@johnsmith12",
    },
    vitals: {
      age: 17,
      birthdate: "2006-08-15",
      hometown: "Austin, TX",
      highSchool: "Central High School",
      height: 75, // in inches
      weight: 195, // in pounds
      wingspan: 78, // in inches
      handSize: 9.5, // in inches
      dominantHand: "Right",
    },
    academics: {
      gpa: 3.7,
      weightedGpa: 4.1,
      satScore: 1280,
      actScore: 28,
      classRank: "15 of 230",
      desiredMajor: "Business Administration",
      eligibilityStatus: "Eligible",
      academicHonors: [
        "Honor Roll (2021-2023)",
        "National Honor Society",
        "Math Competition Finalist",
      ],
      courses: [
        { name: "AP Calculus", grade: "A-" },
        { name: "AP English Literature", grade: "B+" },
        { name: "AP Physics", grade: "A" },
        { name: "AP U.S. History", grade: "B+" },
        { name: "Spanish III", grade: "A" },
      ],
    },
    performance: {
      combine: {
        fortyYard: 4.65,
        verticalJump: 34.5,
        broadJump: 115,
        shuttleRun: 4.2,
        threeCone: 7.1,
        benchPress: 15,
      },
      stats: {
        passingYards: 2850,
        passingTouchdowns: 28,
        interceptions: 8,
        completionPercentage: 68.5,
        rushingYards: 420,
        rushingTouchdowns: 5,
      },
      gameFilm: [
        {
          id: "game1",
          title: "vs. Westlake High",
          date: "2023-10-15",
          stats: "285 yards, 3 TDs, 1 INT",
          url: "https://example.com/film1",
        },
        {
          id: "game2",
          title: "vs. Anderson High",
          date: "2023-09-28",
          stats: "310 yards, 4 TDs, 0 INT",
          url: "https://example.com/film2",
        },
        {
          id: "game3",
          title: "vs. Reagan High",
          date: "2023-09-10",
          stats: "245 yards, 2 TDs, 1 INT",
          url: "https://example.com/film3",
        },
      ],
    },
    videos: [
      {
        id: "video1",
        title: "Junior Year Highlights",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        description:
          "Highlights from the 2022-2023 season showcasing passing and running abilities.",
        uploadDate: "2023-01-15",
        source: "Hudl",
        notes: [
          {
            id: 1,
            time: 15,
            text: "Great throw on the run",
            category: "highlight",
          },
          {
            id: 2,
            time: 45,
            text: "Shows excellent pocket awareness",
            category: "technique",
          },
          {
            id: 3,
            time: 78,
            text: "Needs to improve footwork on deep throws",
            category: "improvement",
          },
        ],
      },
      {
        id: "video2",
        title: "QB Camp Performance",
        url: "https://vimeo.com/236000508",
        description: "Footage from Elite QB Camp showing drills and mechanics.",
        uploadDate: "2023-06-22",
        source: "Elite QB Camp",
        notes: [],
      },
      {
        id: "video3",
        title: "Senior Year Game 1",
        url: "https://www.youtube.com/watch?v=M7lc1UVf-VE",
        description: "Full game footage against Westlake High School.",
        uploadDate: "2023-09-05",
        source: "Team Upload",
        notes: [
          {
            id: 4,
            time: 120,
            text: "Excellent read on this play action",
            category: "highlight",
          },
          {
            id: 5,
            time: 350,
            text: "Forced throw into coverage - risky decision",
            category: "concern",
          },
        ],
      },
      {
        id: "video4",
        title: "Training Session",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        description:
          "Direct video file showing training drills and techniques.",
        uploadDate: "2023-07-10",
        source: "Direct Upload",
        notes: [
          {
            id: 6,
            time: 30,
            text: "Good form on this drill",
            category: "technique",
          },
        ],
      },
    ],
    similarAthletes: [
      {
        id: "athlete1",
        name: "Michael Johnson",
        position: "Quarterback",
        school: "Eastside High",
        location: "Dallas, TX",
        photoUrl: "https://via.placeholder.com/300x160?text=M.Johnson",
        height: 74,
        weight: 190,
        fortyYard: 4.7,
        isWatchlisted: true,
      },
      {
        id: "athlete2",
        name: "David Williams",
        position: "Quarterback",
        school: "North High",
        location: "Houston, TX",
        photoUrl: "https://via.placeholder.com/300x160?text=D.Williams",
        height: 76,
        weight: 200,
        fortyYard: 4.6,
        isWatchlisted: false,
      },
      {
        id: "athlete3",
        name: "Robert Taylor",
        position: "Quarterback",
        school: "South High",
        location: "San Antonio, TX",
        photoUrl: "https://via.placeholder.com/300x160?text=R.Taylor",
        height: 73,
        weight: 185,
        fortyYard: 4.5,
        isWatchlisted: false,
      },
      {
        id: "athlete4",
        name: "James Brown",
        position: "Quarterback",
        school: "West High",
        location: "El Paso, TX",
        photoUrl: "https://via.placeholder.com/300x160?text=J.Brown",
        height: 75,
        weight: 195,
        fortyYard: 4.8,
        isWatchlisted: true,
      },
    ],
    notes: [
      {
        id: 1,
        text: "Showed excellent leadership during campus visit. Interacted well with current players and coaches.",
        category: "character",
        pinned: true,
        date: "2023-10-15T14:30:00Z",
        author: {
          id: "1",
          name: "Coach Anderson",
          avatar: "",
        },
      },
      {
        id: 2,
        text: "Mechanics have improved significantly since junior year. Release is quicker and more compact.",
        category: "performance",
        pinned: false,
        date: "2023-09-28T10:15:00Z",
        author: {
          id: "2",
          name: "Coach Wilson",
          avatar: "",
        },
      },
      {
        id: 3,
        text: "Parents are very supportive of his athletic career but emphasize academic performance as the priority.",
        category: "contact",
        pinned: false,
        date: "2023-08-12T16:45:00Z",
        author: {
          id: "1",
          name: "Coach Anderson",
          avatar: "",
        },
      },
    ],
    contacts: [
      {
        id: 1,
        relationship: "parent",
        name: "Sarah Smith",
        phone: "(555) 123-4567",
        email: "sarah.smith@example.com",
        notes: "Mother - very supportive of athletic career",
      },
      {
        id: 2,
        relationship: "parent",
        name: "Robert Smith",
        phone: "(555) 123-4568",
        email: "robert.smith@example.com",
        notes: "Father - emphasizes academic performance",
      },
      {
        id: 3,
        relationship: "coach",
        name: "Coach Mike Johnson",
        phone: "(555) 987-6543",
        email: "mike.johnson@centralhs.edu",
        notes: "Head Coach at Central High School",
      },
    ],
    communications: [
      {
        id: 1,
        contactId: "1",
        type: "phone",
        date: "2023-10-15T14:30:00Z",
        notes: "Discussed upcoming campus visit and academic requirements",
        outcome: "completed",
        followUpNeeded: true,
        followUpDate: "2023-10-22T00:00:00Z",
      },
      {
        id: 2,
        contactId: "3",
        type: "email",
        date: "2023-10-10T09:15:00Z",
        notes: "Sent game film and updated stats",
        outcome: "completed",
        followUpNeeded: false,
      },
    ],
    events: [
      {
        id: "1",
        date: "2023-06-15T00:00:00Z",
        type: "offer",
        school: "Texas Tech University",
        status: "pending",
        amount: "Full Scholarship",
        details: "Offered after summer camp performance.",
        notes: "Very interested in their offensive system.",
      },
      {
        id: "2",
        date: "2023-07-22T00:00:00Z",
        type: "visit",
        school: "University of Houston",
        status: "completed",
        details: "Unofficial visit to campus.",
        notes: "Liked the facilities and coaching staff.",
      },
      {
        id: "3",
        date: "2023-08-10T00:00:00Z",
        type: "offer",
        school: "SMU",
        status: "pending",
        amount: "Full Scholarship",
        details: "Offered after reviewing game film.",
        notes: "Impressed with academic programs.",
      },
      {
        id: "4",
        date: "2023-09-05T00:00:00Z",
        type: "visit",
        school: "Texas Tech University",
        status: "completed",
        details: "Official visit to campus.",
        notes: "Great experience with team and coaches.",
      },
    ],
  };
};
